import { CircularProgress, type CircularProgressProps } from '@mui/material'

export type MolsonSpinnerProps = CircularProgressProps & {
  dataTestId?: string
}

export const MolsonSpinner = ({ dataTestId, ...props }: MolsonSpinnerProps) => {
  return <CircularProgress data-testid={dataTestId} {...props} />
}
